import { Component, AfterViewInit, Input, HostListener, Output, EventEmitter, ViewChild } from '@angular/core';
import { ProjectData } from 'src/app/entities/project-data.entity';
import * as THREE from 'three';
import { Datas3d } from '../scheme3d/datas3d';
import { GestorSatelite3d } from './gestor-satelite3d';
import { DrawSatelite3d } from './draw-satelite3d';
import { ModelService } from 'src/app/services/model.service';
import { Utils } from 'src/app/utils.module';
import { Router } from '@angular/router';
import { AlertDataTypes } from 'src/app/alert/alert-data.types';
import { AlertData } from 'src/app/alert/alert-data.entity';
import { OrbitControls2 } from './orbit-controls2';
import { BudgetSatelite } from '../budget-satelite';
import { UtilsBuilder } from '../utils-builder';
import { CoorMaps } from '../scheme3d/coor-maps';
//import { Vector } from 'html2canvas/dist/types/render/vector';
import { ProjectDataPerimetro } from '../../entities/project-data-perimetro.entity';
import { AlertComponent } from 'src/app/alert/alert.component';

declare let ga: (p1: any, p2?: any, p3?: any, p4?: any) => {};

@Component({
	selector: 'app-satelite3d',
	templateUrl: './satelite3d.component.html',
	styleUrls: ['./satelite3d.component.scss']
})
export class Satelite3dComponent implements AfterViewInit {

	//#region #################### @Input's
	// Proyecto en curso.
	@Input('projectData') projectData: ProjectData;
	//#endregion

	// Aviso de cambio de zoom.
	@Output() onFinish3DKO: EventEmitter<any> = new EventEmitter();
	@Output() onFinish3DOK: EventEmitter<any> = new EventEmitter();

	//#region #################### Variables locales.
	public root: THREE.Object3D;
	public work: THREE.Object3D;
	public marcador: THREE.Object3D;

	public scene: THREE.Scene;
	private renderer: THREE.WebGLRenderer;
	private camera: THREE.PerspectiveCamera;

	public budgetSatelite: BudgetSatelite;
	private controls: any;

	private Canvas3D;
	private renderRequested = false;
	private initialContinuousRender = true;
	//#endregion

	//#region #################### DATOS USADOS PARA DIBUJAR LOS PERÍMETROS
	public DTNamePerTramo = '';				// Texto usado para ubicar los objetos 3D por perímetro y tramo.
	public DTPerimeterActual: Datas3d;		// Actual perímtero que se está dibujando.
	public DTTramoActual: any;				// Actual tramo que se está dibujando.
	public DTRootTramo: THREE.Object3D;		// Actual root 3D del tramo, usado para añadir nuevos hijos (mesh).

	public DTMetersLUXAnudada = 0;			// Usada para continuar un bastidor de tramoa a tramo cuando es una LUX ANUDADA.

	public DTHasColor = false;				// Si es false -> Galvanizado, en caso contrario tiene un color.
	public DTCacheMaterials = {				// Contiene todos los materiales usados en el perímetro en curso.
		'COL_PlacaBase': undefined,			// Usado para clonar material con el color actual de la placa base.
		'COL_Poste': undefined,
		'COL_Bayoneta': undefined,
		'COL_Bastidor': undefined,
		'COL_Abrazadera': undefined
	};

	public readonly RAD90 = 1.5707963267948966;
	public readonly RAD180 = 3.141592653589793;
	public readonly RAD270 = 4.71238898038469;
	public readonly RAD360 = 6.283185307179586;

	// Variables para configurar y controlar el terreno y perímetro.
	private SGradosLAT = 0;				// Ajuste de los grados de la latitud.
	private SRadianesLAT = 0;			// grados * Math PI / 180
	private SGradosLNG = 0;				// Ajuste de los grados de la longitud.
	private SRadianesLNG = 0;			// grados * Math PI / 180

	private SVectorAdjust: THREE.Vector3;

	private _maximoTiempoPermitido = 0;

	public gestorSatelite3d: GestorSatelite3d;
	//#endregion

	constructor(
		public modelService: ModelService,
		private router: Router
	) { }

	// Se lanza después de la creación de la vista.
	ngAfterViewInit(): void {

		this.scene = new THREE.Scene();
		this.scene.background = new THREE.Color(0x000000);

		this.Canvas3D = document.getElementById('Canvas3D');

		this.Canvas3D.innerWidth = this.Canvas3D.parentElement.clientWidth;
		this.Canvas3D.innerHeight = this.Canvas3D.parentElement.clientHeight;
		this.renderer = new THREE.WebGLRenderer({ canvas: this.Canvas3D, antialias: true });
		this.renderer.setPixelRatio(this.Canvas3D.devicePixelRatio);
		this.renderer.setSize(this.Canvas3D.innerWidth, this.Canvas3D.innerHeight);
		this.renderer.shadowMapEnabled = false;

		this.camera = new THREE.PerspectiveCamera(60, this.Canvas3D.innerWidth / this.Canvas3D.innerHeight, 0.1, 100000);
		this.camera.position.set(0, 66, 66);

		// controls
		this.controls = new OrbitControls2(this.camera, this.renderer.domElement);
		this.controls.enabled = false;
		this.controls.zoomSpeed = 0.8;
		this.controls.rotateSpeed = 0.5;
		this.controls.panSpeed = 0.5;

		this.controls.minDistance = 5;
		this.controls.maxDistance = 200;

		this.controls.maxPolarAngle = Math.PI / 2.2;
		this.controls.minPolarAngle = 0.1;

		// lights
		let lightA = new THREE.AmbientLight(0xbbbbbb);
		this.scene.add(lightA);

		// LIGHTS
		let light = new THREE.DirectionalLight(0xaabbff, 0.3);
		light.position.x = 300;
		light.position.y = 250;
		light.position.z = -500;
		light.castShadow = true;
		this.scene.add(light);
		let light2 = new THREE.DirectionalLight(0xaabbff, 0.3);
		light2.position.x = -300;
		light2.position.y = 250;
		light2.position.z = 500;
		light2.rotation.y = this.RAD180;
		this.scene.add(light);

		//this.main(true);


		//this.animate();

		/*let timeoutVar;
		window.addEventListener('resize', ()=>{
			console.log('resize');
			clearTimeout(timeoutVar);
			if(this.skipRender){
				this.skipRender = false;
			}
			timeoutVar = setTimeout(()=>{
				console.log('stop resizing/rendering');
				this.skipRender = false;
			}, 1000);
		});

		this.controls.addEventListener( 'change',  ()=>{
			//console.log('change');
			clearTimeout(timeoutVar);
			if(this.skipRender){
				this.skipRender = false;
			}
			timeoutVar = setTimeout(()=>{
				console.log('stop controlChange/rendering');
				this.skipRender = false;
			}, 1000);

		} );*/
		this.controls.addEventListener('change', this.render.bind(this));
		window.addEventListener('resize', this.render.bind(this));

		this.main();
		this.animate();
	}

	// #######################################################################################
	// #######################################################################################
	// #######################################################################################

	public ngOnDestroy(): void {
		// console.log('[Satelite3dComponent]: Calling ngOnDestroy');
		//this.initialContinuousRender = true;
		//this.render();

		this.clearScene( this.scene );

		this.scene.dispose();
		this.controls.dispose();
		//this.renderer.getContext().getExtension('WEBGL_lose_context').loseContext();
		//this.renderer.forceContextLoss();
		this.renderer.dispose();

		this.renderer = null;
		this.controls = null;
		this.scene = null;

		// ESPRRIVISA-132
		if (this.gestorSatelite3d !== undefined) {
			this.gestorSatelite3d.releaseResources();
			this.gestorSatelite3d = null;
		}

		this.root = null;

		// console.log('[Satelite3dComponent]: ngOnDestroy finished!');
		//this.Canvas3D = null;

	}

	public clearScene( scene )
	{
		// dispose all geometries and materials in scene
		scene.traverse( object => {
			// dispose geometries (if applies)
			if ( object.geometry ) {
				object.geometry.dispose()
			}

			// dispose materials (check if it's an array or a var!)
			if (object.material) {
				if (object.material.length) {
					let iMatCunt = 0
					for ( iMatCunt = 0; iMatCunt < object.material.length; ++iMatCunt ) {
						object.material[iMatCunt].dispose()
					}
				}
				else {
					object.material.dispose()
				}
			}
		})
	}

	private __debug = false;
	private main(debug = false) {
		ga('send', 'event', {
			eventCategory: 'Satélite 3D',
			eventAction: 'Iniciada'
		});

		this.__debug = debug;
		this.createBudget();
	}
	// Llegados aquí ya se han calculado los perímetros y cargado los objetos 3D.
	private main2() {
		this.initWorld3D();
		this.calcularBoundMap(); // Crear el objeto.
		this.drawBasePerimeters(); // Se crean objetos 3D ocultos en cada base de los perímetros para provocar el calculo de la matriz.
		if (this.__debug) {
			let mat = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
			let dot = new THREE.Mesh(new THREE.ConeGeometry(0.3, 1), mat);
			dot.name = 'Centro';
			dot.position.setY(0.5);
			this.root.add(dot);
		}

		// TODO Rectificar para dejar como antes: Descomentar.
		//	this.work.rotation.set(-this.SRadianesLAT, -(this.SRadianesLNG / 100), 0);

		this.espera();
	}

	// Espera a que se cree todo el mundo.
	private espera() {
		if (this.gestorSatelite3d?.canDraw) {
			// Dibujar.
			let drawSatelite3d = new DrawSatelite3d(this);
			let OK = false;
			setTimeout(() => {
				if (!OK) {
					//this.avisoProblemas3D();
					this.router.navigate(['/satelite']);
					this.onFinish3DKO.emit();
				}
			}, 45000);
			drawSatelite3d.draw();
			OK = true;
			this.controls.meshesMap = this.gestorSatelite3d.meshesMap;
			this.controls.enabled = true;


			//setTimeout(() => {
				this.initialContinuousRender = false;
				this.render();
			//}, 2000);

			this.onFinish3DOK.emit();
		}
		else if (this._maximoTiempoPermitido > 45000) {
			// Avisar que no es pudo crear el mundo.
			console.error('No se pudo crear el mundo 3D.');
			//this.avisoProblemas3D()
			this.router.navigate(['/satelite']);
			this.onFinish3DKO.emit();
		}
		else {
			setTimeout(() => { this.espera(); }, 300);
		}
	}

	/*private avisoProblemas3D() {
		const alertData = new AlertData(); // Crear popup.
		alertData.title = this.modelService.getString('satelite3d_ error_titulo');
		alertData.messages = this.modelService.getString('satelite3d_error_mensaje').split('#');
		alertData.type = AlertDataTypes.ACCEPT;

		this.alertWindow.show(alertData);

		const subWindow = this.modelService.alertResultSignal.subscribe((shouldRemove: boolean) => {
			subWindow.unsubscribe();
			this.alertWindow.close();
			this.router.navigate(['/satelite']);
		});

		//this.modelService.alertSignal.emit(alertData);
	}*/

	private _tiempoMaxWaitBudget = 0;
	private createBudget() {
		// Crear un nuevo presupuesto.
		this.budgetSatelite = new BudgetSatelite(this.projectData);

		// Avisa por consola si el _id del proyecto no existe o está vacío, no modifica.
		if (this.projectData._id == undefined || this.projectData._id == '') {
			// console.log('No tiene id proyecto');
		}

		// En caso de que el proyecto no tenga usuario le asigna el actual, esto no debería pasar.
		if (this.projectData.userId == undefined || this.projectData.userId == ''
			|| this.projectData.userIdRivisa == undefined || this.projectData.userIdRivisa == '') {

			this.projectData.userId = this.modelService.getUser().getData().id;
			this.projectData.userIdRivisa = this.modelService.getUser().getData().numCliRivisa;
		}

		// Si no tiene idioma asignado se le asigna el actual.
		if (!this.projectData.idioma) this.projectData.idioma = this.modelService.getLanguage().currentLanguage;

		this.budgetSatelite.createBudget(true);
		this._tiempoMaxWaitBudget = 0;
		this.waitBudget();
	}
	// Método que espera la gestión del presupuesto, si pasa el tiempo máximo sale y debe avisar que no se pudo realizar.
	private waitBudget() {
		if (this.budgetSatelite.proccessEnd && this.budgetSatelite.datasSatelite.loadFinish) {
			localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
			this.main2();
		}
		else if (this._tiempoMaxWaitBudget > 45000) {
			console.error('Budget:: Tiempo límite pasado.');
			//this.avisoProblemas3D();
			this.router.navigate(['/satelite']);
			this.onFinish3DKO.emit();
		}
		else {
			setTimeout(() => {
				this._tiempoMaxWaitBudget += 300;
				this.waitBudget();
			}, 300);
		}
	}

	private initWorld3D() {
		// Crear root del proyeto (debería ser el centro).
		this.root = new THREE.Object3D();
		this.root.name = 'ROOT';
		this.scene.add(this.root);

		if (this.__debug) {
			let axisHelper = new THREE.AxesHelper(5);
			this.root.add(axisHelper);
		}

		// Grupo de trabajo, contiene puntos base para debug.
		this.work = new THREE.Group();
		this.work.name = 'WORK'
		this.root.add(this.work);

		// Grupo de marcadores, cuando la cámara esté una distancia determinada se hace visible.
		this.marcador = new THREE.Group();
		this.marcador.name = 'MARCADORES';
		this.marcador.visible = false;
		this.root.add(this.marcador);

		//axisHelper = new THREE.AxesHelper(10); this.work.add(axisHelper);
	}

	// Creamos BoundMap (google.maps.LatLngBounds), al que se añade todos los puntos base de todos los perímetros, obteniendo así el rectangulo
	// total. De esta forma se obtiene el centro y se puede decidir cuantas tildes hay que crear.
	private calcularBoundMap() {
		this.gestorSatelite3d = new GestorSatelite3d(this.projectData.perimetro, this.root, this);

		this.SVectorAdjust = UtilsBuilder.latLngToVector3d(this.gestorSatelite3d.lat, this.gestorSatelite3d.lng);
		// VERSIÓN ANTIGUA: CORRECCIÓN DE PERÍMETROS QUE SE ALEJAN DE BARCELONA. LatLngToXYZ
			// TODO Rectificar para dejar como antes: Descomentar.
		//this.SGradosLAT = 90 - this.gestorSatelite3d.lat;
		//this.SRadianesLAT = UtilsBuilder.AngleToRadian(this.SGradosLAT);
		//this.SGradosLNG = 180 - this.gestorSatelite3d.lng;
		//this.SRadianesLNG = UtilsBuilder.AngleToRadian(this.SGradosLNG);
	}

	// Dibuja el perímetro por tramos => secciones.
	public bases = [];
	private drawBasePerimeters() {
		// VERSIÓN ANTIGUA: CORRECCIÓN DE PERÍMETROS QUE SE ALEJAN DE BARCELONA. LatLngToXYZ
		// TODO Rectificar para dejar como antes: Comentar.
		this.SGradosLAT = 90 - this.gestorSatelite3d.lat;
		this.SRadianesLAT = UtilsBuilder.AngleToRadian(this.SGradosLAT);
		this.SGradosLNG = this.gestorSatelite3d.lng;
		this.SRadianesLNG = UtilsBuilder.AngleToRadian(this.SGradosLNG);

		// Conos rojos.
		let cone = new THREE.ConeGeometry(0.01, 0.01);
		const matYellow = new THREE.MeshBasicMaterial({ color: 0xffff00 });
		for (let [ip, p] of this.projectData.perimetro.entries()) {

			// DEBUG
			// this.__debugPerimeter(ip, p);
			// DEBUG

			let subBase = [];
			let g = new THREE.Group();
			g.name = "BASE_" + ip;
			this.work.add(g);
			for (let [id, c] of p.coordenadas.entries()) {
				let v = UtilsBuilder.latLngToVector3d(
					c.dots[0].lat,
					c.dots[0].lng);
				let dot = new THREE.Mesh(cone, matYellow);
				dot.name = 'Tope_' + ip + '_' + id;
				dot.visible = false;
				dot.position.set(v.x - this.SVectorAdjust.x, v.y - this.SVectorAdjust.y, v.z - this.SVectorAdjust.z);
				//dot.rotation.x = this.SRadianesLAT;
				//dot.rotation.z = this.SRadianesLNG;
				g.add(dot);
				subBase.push(dot);
			}
			this.bases.push(subBase);
		}

		this.work.rotation.x = -this.SRadianesLAT;
		this.work.rotation.y = -this.SRadianesLNG;
	}

	private __debugPerimeter (ip:number, p:ProjectDataPerimetro) {
		const matYellow = new THREE.MeshBasicMaterial({ color: 0xffff00 });
		let bl = new THREE.SphereGeometry(0.3);
			let gdb = new THREE.Group();
			gdb.name = 'G_DEBUG';
			this.work.add(gdb);
			for (let index = 0; index < p.post.length; index += CoorMaps.Offset) { // tipoPoste, lat, lng, elevación
				let m = new THREE.Mesh(bl, matYellow);
			 	let v = UtilsBuilder.latLngToVector3d(
					p.post[index + CoorMaps.Lat],
					p.post[index + CoorMaps.Lng],
					UtilsBuilder.EARTH + (p.post[index + CoorMaps.Elevation] / 10)
				);
			 	m.position.set(v.x - this.SVectorAdjust.x, v.y - this.SVectorAdjust.y, v.z - this.SVectorAdjust.z);
			 	m.name = 'DEBUG_' + ip + '_' + index ;
			 	m.rotation.x = this.SRadianesLAT;
			 	gdb.add(m);
			}
	}

	// #######################################################################################
	// Captura el evento de cambio de tamaño de la ventana.
	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.camera.aspect = event.target.innerWidth / event.target.innerHeight;
		this.camera.updateProjectionMatrix();
		this.renderer.setSize(event.target.innerWidth, event.target.innerHeight);
	}

	public skipRender:boolean = false;

	// // Controla la animación de la escena.
	// public animate() {
	// 	requestAnimationFrame(this.render.bind(this));
	// }

	// Controla la animación de la escena.
	private animate() {
		//if (!this.renderRequested) {
		//	this.renderRequested = true;
			if( this.render && this.renderer ) {
				if(this.initialContinuousRender) {
					requestAnimationFrame(this.animate.bind(this));
					this.renderer.render(this.scene, this.camera);
				} else {
					if( this.renderer ) {
						setTimeout(()=>{
							requestAnimationFrame(this.animate.bind(this));
							// ESPRRIVISA-132
							if (this.renderer) {
								this.renderer.render(this.scene, this.camera);
							}
						}, 1000);
					}
				}
			}
		//}
	}


	// Renderiza la escena.
	private render() {
		if( this.renderer?.render && this.scene && this.camera ) {

			//this.renderRequested = false;


			//if(this.initialContinuousRender) {
				//requestAnimationFrame(this.render.bind(this));
			//}

			if (this.marcador && this.controls) {
				if (this.camera.position.distanceTo(this.controls.target) > 130) {
					if (!this.marcador.visible) this.marcador.visible = true;
				}
				else if (this.marcador.visible) this.marcador.visible = false;
			}

			this.renderer.render(this.scene, this.camera);
		}
	}
}
